import { DialogTitle, Divider } from '@mui/material';
import { FetchInvoiceData } from 'pages/invoices/components/InvoiceDetails/InvoiceDetails.types';
import { CorrectiveInvoice, Invoice } from 'pages/invoices/invoices.types';
import { useTranslation } from 'react-i18next';
import * as D from '../../InvoiceLinesPanel.css';
import { InvoiceLineForm } from '../InvoiceLineForm';

type Props = {
  open: boolean;
  invoice: Invoice | CorrectiveInvoice;
  isPrevious?: boolean;
  onClose: () => void;
  refetchInvoiceData: FetchInvoiceData;
};

export const AddInvoiceLineDialog = ({
  open,
  onClose,
  invoice,
  refetchInvoiceData,
  isPrevious,
}: Props) => {
  const { t } = useTranslation(['misc', 'invoice']);

  return (
    <D.StyledDialog open={open} onClose={onClose} maxWidth='md' fullWidth>
      <DialogTitle>
        {`${t('modal.createEntityHeading', { ns: 'misc' })} - ${t('invoice', {
          ns: 'invoice',
        })} ${invoice.code}`}
      </DialogTitle>
      <Divider />
      <InvoiceLineForm
        invoice={invoice}
        onClose={onClose}
        refetchInvoiceData={refetchInvoiceData}
        isPrevious={isPrevious}
      />
    </D.StyledDialog>
  );
};
